import request from '@/http/request'
import {
  getMessageSendList,
  sendMessage,
  getMessageRecordList,
  exportMessageRecord,
  reSendMessage,
  getAskList,
  exportAskList,
  getMessageSendGroupCount
} from '@/http/api'

export const getMessageList = data => {
  return request({
    url: getMessageSendList,
    data
  })
}
export const getMessageSendGroupCountFn = data => {
  return request({
    url: getMessageSendGroupCount,
    data
  })
}

export const sentMessageFn = data => {
  return request({
    url: sendMessage,
    data
  })
}
//getMessageRecordList
export const getMessageRecordListInfo = data => {
  return request({
    url: getMessageRecordList,
    data
  })
}
//exportMessageRecord
export const exportMessageRecordFn = data => {
  return request({
    url: exportMessageRecord,
    data
  })
}

export const reSendMessageFn = data => {
  return request({
    url: reSendMessage,
    data
  })
}
export const getAskListFn = data => {
  return request({
    url: getAskList,
    data
  })
}
export const exportAskListFn = data => {
  return request({
    url: exportAskList,
    data
  })
}